import React from 'react';
import { FileText, Image, Mail, Code, FileSpreadsheet } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';
import { getFileIconType } from './fileIconUtils';

interface FileIconProps {
  fileName?: string | null;
  className?: string;
  size?: 'xs' | 'sm' | 'md';
}

const sizeClasses = { xs: 'w-6 h-6', sm: 'w-8 h-8', md: 'w-10 h-10' };
const iconSizeClasses = { xs: 'w-3.5 h-3.5', sm: 'w-4 h-4', md: 'w-5 h-5' };

export const FileIcon: React.FC<FileIconProps> = ({ fileName, className = '', size = 'md' }) => {
  const { colors } = useTheme();
  const type = getFileIconType(fileName);
  const containerSize = sizeClasses[size];
  const iconSize = iconSizeClasses[size];

  const IconComponent = {
    pdf: FileText,
    image: Image,
    doc: FileText,
    sheet: FileSpreadsheet,
    email: Mail,
    html: Code,
    generic: FileText,
  }[type];

  return (
    <div
      className={cn(
        'flex-shrink-0 flex items-center justify-center rounded-lg',
        containerSize,
        'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400',
        className
      )}
      aria-hidden
    >
      <IconComponent className={iconSize} strokeWidth={1.5} />
    </div>
  );
};

export default FileIcon;
